import { render } from "./UserCareerGame.vue?vue&type=template&id=39c66f7a&scoped=true&ts=true"
import script from "./UserCareerGame.vue?vue&type=script&lang=ts"
export * from "./UserCareerGame.vue?vue&type=script&lang=ts"

import "./UserCareerGame.vue?vue&type=style&index=0&id=39c66f7a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39c66f7a"]])

export default __exports__